module.exports = (parcelRequire.load("hHp3b")).then(() => parcelRequire('eONVA'));